var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[_vm.$style.btn, _vm.$style[_vm.btnStyle]],style:(_vm.cssProps),attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('isClick')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }